import { UserModel, UserRole } from '../models';

export function isUserAnalyst(user: UserModel) {
  return user && user.role === UserRole.Analyst;
}

export function isUserAdvertiser(user?: UserModel) {
  return user && user.role === UserRole.Advertiser;
}

export function isUserPublisher(user?: UserModel) {
  return user && user.role === UserRole.Publisher;
}

// todo: remove after stat test
export function useIsManagerLevel(user: UserModel): boolean {
  const userRole = (user && user.role) || null;

  return [
    UserRole.Admin,
    UserRole.Supervisor,
    UserRole.Manager,
    UserRole.Moderator,
  ].includes(userRole);
}
